import { useState } from 'react';

export const useForceUpdate = () => {
  const [, setValue] = useState(Date.now());
  return () => setValue(Date.now());
};
